import { CommunicationGroupValues } from './types';

export const COMMUNICATION_GROUP_INITIAL_VALUES: CommunicationGroupValues = {
  description: null,
  name: null,
  communicationGroupItems: [],
};
